import React, { PropsWithChildren } from 'react';
import { Result } from 'antd';

import { hasAdminRole } from './adminAccess';

export const RequireAdmin = ({ children }: PropsWithChildren) =>
  hasAdminRole() ? <>{children}</> : <Result status="403" title="Administrator access required" />;
